// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExpandOutlinedSvg from "@ant-design/icons-svg/es/asn/ExpandOutlined";
import AntdIcon from '../components/AntdIcon';

var ExpandOutlined = function ExpandOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExpandOutlinedSvg
  }));
};

ExpandOutlined.displayName = 'ExpandOutlined';
export default React.forwardRef(ExpandOutlined);